// import headerBg2 from "@/assets/images/active/sakura/sheep/header/header_bg2.png";
// import officeBtn from "@/assets/images/active/sakura/sheep/header/btn_08.png";
// import loginBtn from "@/assets/images/active/sakura/sheep/header/btn_06.png";
// import accountBtn from "@/assets/images/active/sakura/sheep/header/btn_07.png";
// import logoutBtn from "@/assets/images/active/sakura/sheep/header/btn_10.png";

export const headerConfig = {
  not_logged_in: {
    background_image: 'https://download4.qcplay.com/h5-images/active/sakura/sheep/header/header_bg2.png',
  },
  logged_in: {
    background_image: 'https://download4.qcplay.com/h5-images/active/sakura/sheep/header/header_bg2.png',
    main_title_color: "#ffe2b6",
    sub_title_color: "#fff",
    tips_color: "#ffe2b6",
    game_name: "魔卡少女樱:回忆钥匙"
  },
  operation_btn: {
    office_website: {
      width: "",
      height: "",
      background_image: "",
      img: 'https://download4.qcplay.com/h5-images/active/sakura/sheep/header/btn_08.png',
      style: "top:45%;transform:translateY(-45%)",
      link: "https://sakura.qingcijoy.com/official/index.html"
    },
    login: {
      width: "",
      height: "",
      background_image: "",
      img: 'https://download4.qcplay.com/h5-images/active/sakura/sheep/header/btn_06.png',
      style: "top:45%;transform:translateY(-45%)"
    },
    change_account: {
      width: "",
      height: "",
      background_image: "",
      img: 'https://download4.qcplay.com/h5-images/active/sakura/sheep/header/btn_07.png',
      style: "top:45%;transform:translateY(-45%)"
    },
    join_active: {
      width: "",
      height: "",
      background_image: "",
      img: "",
      style: ""
    },
    logout: {
      width: "",
      height: "",
      img: 'https://download4.qcplay.com/h5-images/active/sakura/sheep/header/btn_10.png',
      style: "top:45%;transform:translateY(-45%)"
    }
  }
};



// WEBPACK FOOTER //
// ./src/pages/sakura/sheep/headerConfig.js